import { PayloadAction, createSlice, createSelector } from "@reduxjs/toolkit"
import { PURGE } from "redux-persist"
import { RootState } from "./store"

export type ReferenceRouteStatus = {
  isOffRoute: boolean
  jid: string
}

export type ReferenceRouteStatusState = Record<string, ReferenceRouteStatus>

const initialState: ReferenceRouteStatusState = {}

type UpsertReferenceRouteStatusAction = {
  referenceRouteStatus: ReferenceRouteStatus
}

type BatchUpsertReferenceRouteStatusAction = {
  referenceRouteStatuses: ReferenceRouteStatus[]
}

const referenceRouteStatuses = createSlice({
  name: "referenceRouteStatuses",
  initialState,
  reducers: {
    upsertReferenceRouteStatus: (
      state,
      action: PayloadAction<UpsertReferenceRouteStatusAction>,
    ) => {
      state[action.payload.referenceRouteStatus.jid] =
        action.payload.referenceRouteStatus
    },
    removeReferenceRouteStatus: (
      state,
      action: PayloadAction<{ jid: string }>,
    ) => {
      delete state[action.payload.jid]
    },
    batchUpsertReferenceRouteStatuses: (
      state,
      action: PayloadAction<BatchUpsertReferenceRouteStatusAction>,
    ) => {
      for (const status of action.payload.referenceRouteStatuses) {
        state[status.jid] = status
      }

      for (const jid in state) {
        if (
          !action.payload.referenceRouteStatuses.some(
            (status) => status.jid === jid,
          )
        ) {
          delete state[jid]
        }
      }
    },
  },
  extraReducers: (builder) => {
    builder.addCase(PURGE, () => initialState)
  },
})

export const {
  upsertReferenceRouteStatus,
  batchUpsertReferenceRouteStatuses,
  removeReferenceRouteStatus,
} = referenceRouteStatuses.actions

export const selectReferenceRouteStatuses = (state: RootState) =>
  state.referenceRouteStatuses

export const selectReferenceRouteStatus = (jid: string | undefined) => {
  return createSelector(selectReferenceRouteStatuses, (statuses) =>
    jid ? statuses[jid] : undefined,
  )
}

export default referenceRouteStatuses.reducer
